import HttpClient from "./HttpClient";
import environment from "./variables";
import StorageHelper from "./StorageHelper";

class UsersManagement extends HttpClient {
    constructor() {
        super(environment.apiEndpoint!);
    }

    async isStateOrAdminUser() {
        try {
            return await this.client.get("/groups/type", {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`,
                }
            })
        } catch (e) {
            console.error("Can't determine user group")
            throw (e);
        }
    }

    async getUsers(filters?: string[], values?: string[]) {
        try {
            return await this.client.get(`/users${filters && values ?
                `?filter=${filters.map(filter => filter)}&value=${values.map(value => value)}` : ''}`, {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`,
                }
            })
        } catch (e) {
            console.error("Can't get users")
            throw (e);
        }
    }

    async getUser(username: string) {
        try {
            return await this.client.get(`/users/${username}`, {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`,
                }
            })
        } catch (e) {
            console.error("Can't get user")
            throw (e);
        }
    }

    async confirmUser(username: string) {
        try {
            return await this.client.get(`/users/${username}/confirm`, {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't confirm user")
            throw (e);
        }
    }

    async deleteUser(username: string) {
        try {
            return await this.client.delete(`/users/${username}`, {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't delete user")
            throw (e);
        }
    }

    async removeUserFromGroup(username: string, groupName: string) {
        try {
            return await this.client.delete(`/groups/${groupName}/users/${username}`, {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't remove user from group")
            throw (e);
        }
    }

    async createUser(payload: {
        email: string;
        manufacturer: string;
        name: string;
    }) {
        try {
            return await this.client.post(`/users`, payload, {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't create user")
            throw (e);
        }
    }

    async addUserToGroup(username: string, group: string) {
        try {
            return await this.client.post(`/groups/${group}/users`, {
                username
            }, {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't add user to group")
            throw (e);
        }
    }
}

export default UsersManagement;
